const pageNameKey = "aiRagChat";

export const aiRagChatEn = {
  [pageNameKey]: {
    imageRemoveAlt: "Remove image",
    imagePickerLabel: "Upload images",
    imageTooMany: "You can select up to 3 images.",
    imageSizeTooLarge: "Each image must be smaller than 5MB.",
    imageInvalidType: "Please select image files (JPEG, PNG or WebP).",
    subtitle: "Things AI Support",
    conversationHistory: "Conversation history",
    newConversation: "New conversation",
    confirmResetTitle: "Start a new conversation?",
    confirmResetMessage:
      "This will clear the current chat history. This action cannot be undone.",
    confirmResetAction: "Start new conversation",
    cancelResetAction: "Cancel",
    getStartedQuestionText: "Ask a question to get started!",
    errorFetchingChatText:
      "An error occurred while fetching the chat. Please try again later.",
    errorSendingFeedback: "Failed to send feedback, please try again.",
    errorStreamAnswer: "Sorry, something went wrong.",
    errorUnexpectedStreamEnd: "Stream ended unexpectedly.",
    errorNoBodyStreamAnswer: "No response body received from the server.",
    toolActivityLabel: "Tool activity",
    thinkingBubbleText: "Thinking...",
  },
};

export const aiRagChatPtBr = {
  [pageNameKey]: {
    imageRemoveAlt: "Remover imagem",
    imagePickerLabel: "Enviar imagens",
    imageTooMany: "Você pode selecionar até 3 imagens.",
    imageSizeTooLarge: "Cada imagem deve ter menos de 5MB.",
    imageInvalidType: "Selecione arquivos de imagem (JPEG, PNG ou WebP).",
    subtitle: "Suporte da IA do Things",
    conversationHistory: "Histórico da conversa",
    newConversation: "Nova conversa",
    confirmResetTitle: "Iniciar uma nova conversa?",
    confirmResetMessage:
      "Isso limpará o histórico atual do chat. Esta ação não pode ser desfeita.",
    confirmResetAction: "Iniciar nova conversa",
    cancelResetAction: "Cancelar",
    getStartedQuestionText: "Faça uma pergunta para começar!",
    errorFetchingChatText:
      "Ocorreu um erro ao buscar o chat. Tente novamente mais tarde.",
    errorSendingFeedback: "Falha ao enviar o feedback, tente novamente.",
    errorStreamAnswer: "Desculpe, algo deu errado.",
    errorUnexpectedStreamEnd: "O stream terminou inesperadamente.",
    errorNoBodyStreamAnswer: "Nenhum corpo de resposta recebido do servidor.",
    toolActivityLabel: "Atividade da ferramenta",
    thinkingBubbleText: "Pensando...",
  },
};

export const aiRagChatDe = {
  [pageNameKey]: {
    imageRemoveAlt: "Bild entfernen",
    imagePickerLabel: "Bilder hochladen",
    imageTooMany: "Du kannst bis zu 3 Bilder auswählen.",
    imageSizeTooLarge: "Jedes Bild muss kleiner als 5MB sein.",
    imageInvalidType: "Bitte wähle Bilddateien (JPEG, PNG oder WebP) aus.",
    subtitle: "Things AI Support",
    conversationHistory: "Verlauf der Unterhaltung",
    newConversation: "Neue Unterhaltung",
    confirmResetTitle: "Neue Unterhaltung starten?",
    confirmResetMessage:
      "Dadurch wird der aktuelle Chatverlauf gelöscht. Diese Aktion kann nicht rückgängig gemacht werden.",
    confirmResetAction: "Neue Unterhaltung starten",
    cancelResetAction: "Abbrechen",
    getStartedQuestionText: "Stellen Sie eine Frage, um zu beginnen!",
    errorFetchingChatText:
      "Beim Abrufen des Chats ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.",
    errorSendingFeedback:
      "Fehler beim Senden des Feedbacks, bitte versuchen Sie es erneut.",
    errorStreamAnswer: "Entschuldigung, etwas ist schief gelaufen.",
    errorUnexpectedStreamEnd: "Der Stream endete unerwartet.",
    errorNoBodyStreamAnswer: "Keine Antwort vom Server erhalten.",
    toolActivityLabel: "Tool-Aktivität",
    thinkingBubbleText: "Denke nach...",
  },
};

export const aiRagChatZhHans = {
  [pageNameKey]: {
    imageRemoveAlt: "移除图片",
    imagePickerLabel: "上传图片",
    imageTooMany: "最多可以选择3张图片。",
    imageSizeTooLarge: "每张图片必须小于5MB。",
    imageInvalidType: "请选择图片文件（JPEG、PNG 或 WebP）。",
    subtitle: "Things AI 技术​支持",
    conversationHistory: "对话历史",
    newConversation: "新建对话",
    confirmResetTitle: "开始新对话？",
    confirmResetMessage: "这将清除当前聊天记录。此操作无法撤销。",
    confirmResetAction: "开始新对话",
    cancelResetAction: "取消",
    getStartedQuestionText: "提出一个问题以开始！",
    errorFetchingChatText: "获取聊天时发生错误。请稍后再试。",
    errorSendingFeedback: "发送反馈失败，请重试。",
    errorStreamAnswer: "抱歉，出了点问题。",
    errorUnexpectedStreamEnd: "流意外结束。",
    errorNoBodyStreamAnswer: "未从服务器收到响应体。",
    toolActivityLabel: "工具活动",
    thinkingBubbleText: "思考中...",
  },
};

export const aiRagChatIt = {
  [pageNameKey]: {
    imageRemoveAlt: "Rimuovi immagine",
    imagePickerLabel: "Carica immagini",
    imageTooMany: "Puoi selezionare fino a 3 immagini.",
    imageSizeTooLarge: "Ogni immagine deve essere inferiore a 5MB.",
    imageInvalidType: "Seleziona file immagine (JPEG, PNG o WebP).",
    subtitle: "Supporto Things AI",
    conversationHistory: "Cronologia conversazione",
    newConversation: "Nuova conversazione",
    confirmResetTitle: "Iniziare una nuova conversazione?",
    confirmResetMessage:
      "Questa azione cancellerà la cronologia chat corrente. L'operazione non può essere annullata.",
    confirmResetAction: "Inizia nuova conversazione",
    cancelResetAction: "Annulla",
    getStartedQuestionText: "Fai una domanda per iniziare!",
    errorFetchingChatText:
      "Si è verificato un errore durante il recupero della chat. Per favore riprova più tardi.",
    errorSendingFeedback: "Impossibile inviare il feedback, riprova.",
    errorStreamAnswer: "Spiacenti, qualcosa è andato storto.",
    errorUnexpectedStreamEnd:
      "La trasmissione dati è terminata inaspettatamente.",
    errorNoBodyStreamAnswer:
      "Nessun contenuto nella risposta ricevuta dal server.",
    toolActivityLabel: "Attività dello strumento",
    thinkingBubbleText: "Sto pensando...",
  },
};

export const aiRagChatEs = {
  [pageNameKey]: {
    imageRemoveAlt: "Eliminar imagen",
    imagePickerLabel: "Subir imágenes",
    imageTooMany: "Puedes seleccionar hasta 3 imágenes.",
    imageSizeTooLarge: "Cada imagen debe tener menos de 5MB.",
    imageInvalidType: "Selecciona archivos de imagen (JPEG, PNG o WebP).",
    subtitle: "Aspectos que AI admite",
    conversationHistory: "Historial de conversación",
    newConversation: "Nueva conversación",
    confirmResetTitle: "¿Iniciar una nueva conversación?",
    confirmResetMessage:
      "Esto borrará el historial actual del chat. Esta acción no se puede deshacer.",
    confirmResetAction: "Iniciar nueva conversación",
    cancelResetAction: "Cancelar",
    getStartedQuestionText: "¡Haz una pregunta para empezar!",
    errorFetchingChatText:
      "Se produjo un error al cargar el chat. Vuelve a intentarlo más tarde.",
    errorSendingFeedback:
      "No se pudo enviar los comentarios, inténtalo de nuevo.",
    errorStreamAnswer: "Lo siento, algo salió mal.",
    errorUnexpectedStreamEnd: "El flujo terminó inesperadamente.",
    errorNoBodyStreamAnswer:
      "No se recibió ningún cuerpo de respuesta del servidor.",
    toolActivityLabel: "Actividad de la herramienta",
    thinkingBubbleText: "Pensando...",
  },
};

export const aiRagChatNl = {
  [pageNameKey]: {
    imageRemoveAlt: "Afbeelding verwijderen",
    imagePickerLabel: "Afbeeldingen uploaden",
    imageTooMany: "Je kunt maximaal 3 afbeeldingen selecteren.",
    imageSizeTooLarge: "Elke afbeelding moet kleiner zijn dan 5MB.",
    imageInvalidType: "Selecteer afbeeldingsbestanden (JPEG, PNG of WebP).",
    cancelResetAction: "Cancel",
    confirmResetAction: "Start new conversation",
    confirmResetMessage:
      "This will clear the current chat history. This action cannot be undone.",
    confirmResetTitle: "Start a new conversation?",
    conversationHistory: "Conversation history",
    errorFetchingChatText:
      "Er is een fout opgetreden bij het ophalen van de chat. Probeer het later opnieuw.",
    errorNoBodyStreamAnswer: "No response body received from the server.",
    errorSendingFeedback:
      "Fout bij het verzenden van de feedback, probeer het opnieuw.",
    errorStreamAnswer: "Sorry, something went wrong.",
    errorUnexpectedStreamEnd: "Stream ended unexpectedly.",
    getStartedQuestionText: "Stel een vraag om te beginnen!",
    newConversation: "New conversation",
    subtitle: "Things AI-ondersteuning",
    toolActivityLabel: "Toolactiviteit",
    thinkingBubbleText: "Denkt na...",
  },
};

export const aiRagChatTr = {
  [pageNameKey]: {
    imageRemoveAlt: "Görseli kaldır",
    imagePickerLabel: "Görsel yükle",
    imageTooMany: "En fazla 3 görsel seçebilirsiniz.",
    imageSizeTooLarge: "Her görsel 5 MB'tan küçük olmalıdır.",
    imageInvalidType: "Lütfen JPEG, PNG veya WebP biçiminde görsel seçin.",
    cancelResetAction: "İptal etmek",
    confirmResetAction: "Yeni görüşme başlat",
    confirmResetMessage:
      "Bu, mevcut sohbet geçmişini temizleyecektir. Bu eylem geri alınamaz.",
    confirmResetTitle: "Yeni bir sohbet başlatılsın mı?",
    conversationHistory: "Konuşma geçmişi",
    errorFetchingChatText:
      "Sohbet alınırken bir hata oluştu. Lütfen daha sonra tekrar deneyin.",
    errorNoBodyStreamAnswer: "Sunucudan yanıt gövdesi alınmadı.",
    errorSendingFeedback: "Geri bildirim gönderilemedi, lütfen tekrar deneyin.",
    errorStreamAnswer: "Üzgünüz, bir şeyler ters gitti.",
    errorUnexpectedStreamEnd: "Akış beklenmedik bir şekilde sona erdi.",
    getStartedQuestionText: "Başlamak için bir soru sorun!",
    newConversation: "Yeni görüşme",
    subtitle: "Nesnelerin Yapay Zekası Desteği",
    thinkingBubbleText: "Düşünüyorum...",
    toolActivityLabel: "Araç etkinliği",
  },
};
